<template>
  <div class="overview">
    <!-- {{ studentData.setGradeL }} -->
    <!-- <div class="overview-title">
      共性错题数量 {{ questionData.questionCount }} 平均得分率
      {{ questionData.scoreRateAvg | setNumber }}
    </div> -->
    <div class="overview-table-box">
      <div class="overview-table overview-table-box-title">
        <div>题型</div>
        <div>数量</div>
        <div>得分率</div>
      </div>
      <div
        v-for="(v, i) in questionData.questionTypeList"
        :key="i"
        class="overview-table"
      >
        <div>{{ v.questionType }}</div>
        <div>{{ v.questionCount }}</div>
        <div>{{ v.scoreRate | setNumber }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { optionsTime, subjectOptions } from "@/util/constdata";
// knowledgeInfo
import {
  knowledgeInfo,
  questionInfo,
  getGradelist,
  studentsummary,
  querypage,
} from "@/api/interface";
export default {
  name: "",
  filters: {
    setVal(val) {
      return (val * 100).toFixed(2);
    },
  },
  props: { searchData: Object },
  data() {
    return {
      subjectOptions: subjectOptions,
      optionsTime: optionsTime,
      knowledgeData: {},
      questionData: {},
      optionYear: [],
      studentList: [],
      studentData: {},
    };
  },
  created() {
    this.info();
    // console.log("111111111111");
    // if (!this.$route.query.isStudent) {
    // this.getOption();
    // }
    // if (this.$route.query.studentId) {
    //   this.getStudentInfo();
    // }
  },
  methods: {
    drawLine() {
      // this.studentData.classRate
      // 计算值
      this.studentData.setClass = (this.studentData.classRate * 100).toFixed(2);
      this.studentData.setGrade = (this.studentData.gradeRate * 100).toFixed(2);
      if (this.studentData.setClass < 50) {
        this.studentData.setClassL = parseInt(
          225 - (135 * this.studentData.setClass) / 100
        );
      } else {
        this.studentData.setClassL = parseInt(
          90 - ((this.studentData.setClass - 50) * 2 * 135) / 100
          // 315 - (this.studentData.setClass * 315) / 100
        );
      }
      if (this.studentData.setGrade < 50) {
        this.studentData.setGradeL = parseInt(
          225 - (135 * this.studentData.setGrade) / 100
        );
      } else {
        this.studentData.setGradeL = parseInt(
          90 - ((this.studentData.setGrade - 50) * 2 * 135) / 100
          // 315 - (this.studentData.setClass * 315) / 100
        );
      }

      // console.log(this.studentData);
      // 计算角度
      // 如果低于50%，225-135*（x）/100
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById("myChartL"));
      // 绘制图表
      myChart.setOption({
        tooltip: {
          formatter: "{a} <br/>{b} : {c}%",
        },
        grid: {
          // top: '4%',
          left: "0%",
          right: "0%",
          bottom: "0%",
          containLabel: true,
        },
        series: [
          {
            name: "百分比100%",
            type: "gauge",
            //半径
            radius: 60,
            //起始角度。圆心 正右手侧为0度，正上方为90度，正左手侧为180度。
            startAngle: 225,
            //结束角度。
            endAngle: 315,
            center: ["50%", "50%"],
            //仪表盘轴线相关配置。
            axisLine: {
              // 坐标轴线
              show: true,
              lineStyle: {
                // 属性lineStyle控制线条样式
                width: 5,
                color: [[1, "#F2F4FF"]],
              },
            },
            //分隔线样式。
            splitLine: {
              show: false,
            },
            //刻度样式
            axisTick: {
              show: false,
            },
            //刻度标签。
            axisLabel: {
              show: false,
            },
            //仪表盘指针。
            pointer: {
              //这个show属性好像有问题，因为在这次开发中，需要去掉指正，我设置false的时候，还是显示指针，估计是BUG吧，我用的echarts-3.2.3；希望改进。最终，我把width属性设置为0，成功搞定！
              show: false,
              //指针长度
              length: "90%",
              width: 0,
            },
            //仪表盘标题。
            title: {
              // text: "班级前",
              show: true,
              offsetCenter: [0, "100%"], // x, y，单位px
              textStyle: {
                color: "#000000",
                fontSize: 14,
              },
            },
            //仪表盘详情，用于显示数据。
            detail: {
              show: true,
              // offsetCenter: [0, '-40%'],
              formatter: "{value}%",
              textStyle: {
                fontSize: 14,
                color: "#7b9cc7",
              },
            },
            data: [{ value: this.studentData.setClass, name: "班级前" }],
            zlevel: 1,
          },
          {
            name: "进度条",
            type: "gauge",
            //半径
            radius: 60,
            //起始角度。圆心 正右手侧为0度，正上方为90度，正左手侧为180度。
            startAngle: 225,
            //结束角度。
            endAngle: this.studentData.setClassL,
            // 			center: ['50%', '50%'],
            //仪表盘轴线相关配置。
            axisLine: {
              // 坐标轴线
              show: true,
              lineStyle: {
                // 属性lineStyle控制线条样式
                width: 5,
                color: [[1, "#7b9cc7"]],
              },
            },
            //分隔线样式。
            splitLine: {
              show: true,
              length: 10,
              lineStyle: {
                color: "white",
                width: 0,
              },
            },
            //刻度样式
            axisTick: {
              show: false,
            },
            //刻度标签。
            axisLabel: {
              show: false,
            },
            //仪表盘指针。
            pointer: {
              //这个show属性好像有问题，因为在这次开发中，需要去掉指正，我设置false的时候，还是显示指针，估计是BUG吧，我用的echarts-3.2.3；希望改进。最终，我把width属性设置为0，成功搞定！
              show: false,
            },
            //仪表盘标题。
            title: {
              show: false,
            },
            //仪表盘详情，用于显示数据。
            detail: {
              show: false,
              offsetCenter: [0, "-10%"],
              formatter: "",
              textStyle: {
                fontSize: 0,
              },
            },
            data: [{ name: "数量", value: 100 }],
            zlevel: 1,
          },
        ],
      });
      let myChart1 = this.$echarts.init(document.getElementById("myChartF"));
      // 绘制图表
      myChart1.setOption({
        tooltip: {
          formatter: "{a} <br/>{b} : {c}%",
        },

        grid: {
          // top: '4%',
          left: "0%",
          right: "0%",
          bottom: "0%",
          containLabel: true,
        },
        series: [
          {
            name: "百分比100%",
            type: "gauge",
            //半径
            radius: 60,
            //起始角度。圆心 正右手侧为0度，正上方为90度，正左手侧为180度。
            startAngle: 225,
            //结束角度。
            endAngle: 315,
            center: ["50%", "50%"],
            //仪表盘轴线相关配置。
            axisLine: {
              // 坐标轴线
              show: true,
              lineStyle: {
                // 属性lineStyle控制线条样式
                width: 5,
                color: [[1, "#F2F4FF"]],
              },
            },
            //分隔线样式。
            splitLine: {
              show: false,
            },
            //刻度样式
            axisTick: {
              show: false,
            },
            //刻度标签。
            axisLabel: {
              show: false,
            },
            //仪表盘指针。
            pointer: {
              //这个show属性好像有问题，因为在这次开发中，需要去掉指正，我设置false的时候，还是显示指针，估计是BUG吧，我用的echarts-3.2.3；希望改进。最终，我把width属性设置为0，成功搞定！
              show: false,
              //指针长度
              length: "90%",
              width: 0,
            },
            //仪表盘标题。
            title: {
              // text: "班级前",
              show: true,
              offsetCenter: [0, "100%"], // x, y，单位px
              textStyle: {
                color: "#000000",
                fontSize: 14,
              },
            },
            //仪表盘详情，用于显示数据。
            detail: {
              show: true,
              // offsetCenter: [0, '-40%'],
              formatter: "{value}%",
              textStyle: {
                fontSize: 14,
                color: "#7b9cc7",
              },
            },
            data: [{ value: this.studentData.setGrade, name: "年级前" }],
            zlevel: 1,
          },
          {
            name: "进度条",
            type: "gauge",
            //半径
            radius: 60,
            //起始角度。圆心 正右手侧为0度，正上方为90度，正左手侧为180度。
            startAngle: 225,
            //结束角度。
            endAngle: this.studentData.setGradeL,
            // 			center: ['50%', '50%'],
            //仪表盘轴线相关配置。
            axisLine: {
              // 坐标轴线
              show: true,
              lineStyle: {
                // 属性lineStyle控制线条样式
                width: 5,
                color: [[1, "#7b9cc7"]],
              },
            },
            //分隔线样式。
            splitLine: {
              show: true,
              length: 10,
              lineStyle: {
                color: "white",
                width: 0,
              },
            },
            //刻度样式
            axisTick: {
              show: false,
            },
            //刻度标签。
            axisLabel: {
              show: false,
            },
            //仪表盘指针。
            pointer: {
              //这个show属性好像有问题，因为在这次开发中，需要去掉指正，我设置false的时候，还是显示指针，估计是BUG吧，我用的echarts-3.2.3；希望改进。最终，我把width属性设置为0，成功搞定！
              show: false,
            },
            //仪表盘标题。
            title: {
              show: false,
            },
            //仪表盘详情，用于显示数据。
            detail: {
              show: false,
              offsetCenter: [0, "-10%"],
              formatter: "",
              textStyle: {
                fontSize: 0,
              },
            },
            data: [{ name: "数量", value: 100 }],
            zlevel: 1,
          },
        ],
      });
    },
    getStudentInfo() {
      let data = JSON.parse(JSON.stringify(this.searchData));
      data.current = 1;
      data.size = 100;
      studentsummary(this.searchData).then((res) => {
        this.studentData = res.data;
        // console.log(res);
        this.$nextTick(() => {
          this.drawLine();
        });
      });
      if (!this.$route.query.isStudent) {
        querypage(data).then((res) => {
          this.studentList = res.data.records;
        });
      }
    },
    getOption() {
      // 初始化年级
      // let data = {
      //   token: this.searchData.token,
      //   schoolID: this.searchData.schoolID
      // };
      getGradelist().then((res) => {
        this.optionYear = res.data;
      });
    },
    info() {
      knowledgeInfo(this.searchData).then((res) => {
        // console.log(res);
        this.knowledgeData = res.data;
      });
      questionInfo(this.searchData).then((res) => {
        // console.log(res);
        this.questionData = res.data;
      });
    },
  },
};
</script>
<style scoped lang="scss">
.overview {
  padding: 0 12px;
  .student-box {
    .chart-box {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;
      margin-bottom: 20px;
    }
    .student-box-top {
      .student-box-title {
        margin-top: 10px;
      }
      span {
        color: #7b9cc7;
      }
    }
  }
  p {
    margin-bottom: 10px;
  }
  .know-title {
    color: rgba(0, 0, 0, 1);
    padding-bottom: 14px;
    font-size: 16px;
  }
  .message {
    padding: 14px 0;
    color: rgba(0, 0, 0, 0.85);
    span {
      color: #7b9cc7;
    }
  }
  .overview-title {
    padding: 14px 0;
  }
  .overview-table-box {
    border: 1px solid #e0e0e0;
    .overview-table {
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #e0e0e0;
      &:last-child {
        border-bottom: none;
      }
      .err {
        color: #fc5743;
      }
      div {
        width: 33.33%;
        padding: 14px 8px;
        text-align: center;
        color: rgba(0, 0, 0, 0.85);
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }
    .overview-table-box-title {
      div {
        color: rgba(0, 0, 0, 0.5);
      }
    }
  }
}
</style>
